module.exports = __webpack_public_path__ + "static/media/iron-man-black-bg.04570b6a.png";